import type { FC } from 'react'
import styles from './switch.module.css'

export interface SwitchProps {
  checked?: boolean
  defaultChecked?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  onCheckedChange?: (checked: boolean) => void
  disabled?: boolean
  name?: string
  color?: 'primary' | 'secondary' | 'default'
  size?: 'small' | 'medium'
  className?: string
  style?: React.CSSProperties
  id?: string
  'aria-label'?: string
  value?: string | boolean
}

export const Switch: FC<SwitchProps> = ({
  checked,
  defaultChecked,
  onChange,
  onCheckedChange,
  disabled,
  name,
  size: _size = 'medium',
  className,
  style,
  id,
  'aria-label': ariaLabel,
}) => {
  const classes = [styles.switch, className].filter(Boolean).join(' ')

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onCheckedChange?.(e.target.checked)
    onChange?.(e)
  }

  return (
    <label className={classes} style={style}>
      <input
        type="checkbox"
        className={styles.input}
        checked={checked}
        defaultChecked={defaultChecked}
        disabled={disabled}
        name={name}
        id={id}
        aria-label={ariaLabel}
        onChange={handleChange}
      />
      <span className={styles.switchTrack} />
      <span className={styles.thumb} />
    </label>
  )
}
